import {flatten, pathOr, pipe, propOr} from 'ramda'

const state = {
  errors: [],
  message: '',
  isError: false,
}

export const mutationTypes = {
  setErrors: '[errors] set errors',
  clearErrors: '[errors] clear errors',
}

export const actionTypes = {
  setErrors: '[errors] set errors',
  clearErrors: '[errors] clear errors',
}

const mutations = {
  [mutationTypes.setErrors](state, payload) {
    state.errors = pipe(propOr([], 'errors'), Object.values, flatten)(payload)
    const error = pathOr(payload, ['response', 'data', 'message'], payload)
    if (error.length) {
      state.message = pathOr(payload, ['response', 'data', 'message'], payload)
    } else {
      // eslint-disable-next-line no-console
      console.error(payload.response.config.url, 'error')
      state.message = payload.toString()
    }

    state.isError = true
  },

  [mutationTypes.clearErrors](state) {
    state.errors = []
    state.message = ''
    state.isError = false
  },
}

export default {
  state,
  mutations,
}
